<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KT7IXB/tc-custom/9781685506308.jpg?1724432671672" alt="This image is the cover for the book Glad Tidings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Glad Tidings
      </h1>
      <p class="bookDescription body article font2">
        <p>After being disowned by his father, Emery Halloran relocates from Haydon Cliff to Sutter’s Bay, whereupon after a small inheritance he opens his dream business, Glad Tidings bakery. It’s his first holiday season in Sutter’s Bay when he receives a visit from his high school crush, Matthias Constantine, who is now acting as Emery’s great uncle’s lawyer.<br/><br/>Great Uncle Sherman is all alone in Haydon Cliff now that his husband is gone and he wants to connect with his last remaining relative, Emery. With the Christmas holiday approaching, Sherman wants to get to know Emery so that he can leave his estate to his great nephew someday. And it’s also a great chance to reconnect with Matthias, who is now divorced and anxious to get to know Emery again.<br/><br/>Is it time for Emery to return to his home town of Haydon Cliff for the holidays and beyond?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shawn Lane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03854626